import React from 'react';
import { motion } from 'framer-motion';
// Stylized abstract map: USA outline (top-left) → Venezuela (bottom-right)
// with an animated dashed great-circle line and gold pulse nodes.
export function USAVenezuelaMap({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 800 500" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" data-id="element-145">
      <defs data-id="element-146">
        <radialGradient id="usGlow" cx="50%" cy="50%" r="50%" data-id="element-147">
          <stop offset="0%" stopColor="#C9A961" stopOpacity="0.35" data-id="element-148" />
          <stop offset="100%" stopColor="#C9A961" stopOpacity="0" data-id="element-149" />
        </radialGradient>
        <radialGradient id="vzGlow" cx="50%" cy="50%" r="50%" data-id="element-150">
          <stop offset="0%" stopColor="#C9A961" stopOpacity="0.35" data-id="element-151" />
          <stop offset="100%" stopColor="#C9A961" stopOpacity="0" data-id="element-152" />
        </radialGradient>
      </defs>

      {/* Latitude/longitude grid lines */}
      <g stroke="rgba(201,169,97,0.08)" strokeWidth="0.5" data-id="element-153">
        {[80, 160, 240, 320, 400].map(y => <line key={y} x1="0" y1={y} x2="800" y2={y} data-id="element-154" />)}
        {[100, 200, 300, 400, 500, 600, 700].map(x => <line key={x} x1={x} y1="0" x2={x} y2="500" data-id="element-155" />)}
      </g>

      {/* Stylized USA shape (abstract) */}
      <g opacity="0.85" data-id="element-156">
        <circle cx="200" cy="160" r="80" fill="url(#usGlow)" data-id="element-157" />
        <path d="M120 130 L160 110 L220 105 L280 120 L300 145 L290 180 L260 200 L210 210 L165 200 L130 175 Z" stroke="rgba(201,169,97,0.55)" strokeWidth="1" fill="rgba(27,58,107,0.25)" data-id="element-158" />
        <text x="200" y="240" textAnchor="middle" fontSize="11" fill="rgba(201,169,97,0.9)" fontFamily="JetBrains Mono, monospace" letterSpacing="2" data-id="element-159">
          UNITED STATES
        </text>
      </g>

      {/* Stylized Venezuela shape (abstract) */}
      <g opacity="0.85" data-id="element-160">
        <circle cx="600" cy="360" r="60" fill="url(#vzGlow)" data-id="element-161" />
        <path d="M555 335 L590 325 L630 330 L650 350 L645 380 L625 395 L590 395 L565 380 L555 360 Z" stroke="rgba(201,169,97,0.55)" strokeWidth="1" fill="rgba(27,58,107,0.25)" data-id="element-162" />
        <text x="600" y="430" textAnchor="middle" fontSize="11" fill="rgba(201,169,97,0.9)" fontFamily="JetBrains Mono, monospace" letterSpacing="2" data-id="element-163">
          VENEZUELA
        </text>
      </g>

      {/* Connecting curve */}
      <motion.path d="M 240 175 Q 420 90 600 340" stroke="rgba(201,169,97,0.35)" strokeWidth="1.2" fill="none" initial={{
      pathLength: 0
    }} animate={{
      pathLength: 1
    }} transition={{
      duration: 2.2,
      ease: 'easeOut',
      delay: 0.3
    }} data-id="element-164" />
      <path d="M 240 175 Q 420 90 600 340" stroke="#C9A961" strokeWidth="1.5" fill="none" className="map-dash" opacity="0.9" data-id="element-165" />

      {/* End nodes */}
      <circle cx="240" cy="175" r="4" fill="#C9A961" className="pulse-gold" data-id="element-166" />
      <circle cx="600" cy="340" r="4" fill="#C9A961" className="pulse-gold" style={{
      animationDelay: '1s'
    }} data-id="element-167" />

      {/* Compass tick */}
      <g fontFamily="JetBrains Mono, monospace" fontSize="9" fill="rgba(255,255,255,0.4)" data-id="element-168">
        <text x="20" y="30" data-id="element-169">
          N 30°
        </text>
        <text x="20" y="480" data-id="element-170">
          N 8°
        </text>
      </g>
    </svg>;
}